import Vue from "vue"
import VueI18n from "vue-i18n"
import en from "@/locales/en.json"
import ar from "@/locales/ar.json"
import es from "@/locales/es.json"
import fr from "@/locales/fr.json"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: { en, ar, es, fr }, // set locale messages
})

export default i18n
